import React, { useState, useCallback } from 'react';
import { Icon } from '../Icon';
import UserMenu from './UserMenu';
const UserMenuContainer = ({ userId = '', productPrefix = '', onThemeChange, selectedTheme, onContextChange, selectedContext, onLogout, customUserMenuItems, overrideUserMenuItems, }) => {
    const [showMenu, setShowMenu] = useState(false);
    const handleToggleMenu = useCallback(() => {
        setShowMenu((value) => !value);
    }, []);
    const menuItemsData = [
        {
            text: `Context: ${selectedContext}`,
            iconSource: 'Context',
            handler: onContextChange,
        },
        {
            text: `Switch to ${selectedTheme} theme`,
            iconSource: 'ThemeSwitcher',
            handler: onThemeChange,
        },
        {
            text: `Log Out`,
            iconSource: 'LogOut',
            handler: onLogout,
        },
    ];
    const menuItems = [];
    if (!overrideUserMenuItems) {
        menuItems.push(...menuItemsData);
    }
    if (customUserMenuItems) {
        menuItems.push(...customUserMenuItems);
    }
    const itemClickHandler = (itemHandler) => {
        if (itemHandler) {
            itemHandler();
        }
        handleToggleMenu();
    };
    return (React.createElement(UserMenu, { showMenu: showMenu, toggleMenu: handleToggleMenu, setShowMenu: setShowMenu, user: userId, productPrefix: productPrefix }, menuItems.map((item) => (React.createElement("button", { type: "button", className: "menu-button", onClick: () => itemClickHandler(item.handler), key: `menu-button-${item.text}` },
        React.createElement("div", null,
            React.createElement(Icon, { source: item.iconSource })),
        React.createElement("div", { className: "button-label" }, item.text))))));
};
export default UserMenuContainer;
//# sourceMappingURL=UserMenuContainer.js.map